import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { PurchaseKindRepositoryBase } from '@skylab-shared/business';
export { PurchaseKindRepositoryBase };

@Injectable({ providedIn: 'root'})
@Wrapper(PurchaseKindRepositoryBase)
export class PurchaseKindRepository {
    public constructor(
        weaver: Weaver,
        http: Http
    ) { }
}
